export default function useConfigureMobilePushNotificationsViewModel() {
  // The /:utility?/download route renders DownloadAppRedirect, which detects
  // iOS vs Android via react-device-detect and forwards to the matching store.
  // Encoding the same-origin URL keeps the QR consistent with any white-label
  // utility basePath the user is currently on.
  const qrUrl = `${window.location.origin}/download`
  return { qrUrl }
}
